import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formControl: {
    '& .MuiFormLabel-asterisk': {
      color: theme.palette.error.main,
    },
    '& .MuiInputLabel-asterisk': {
      color: theme.palette.error.main,
    },
    '& .MuiInputLabel-formControl:not(.MuiInputLabel-shrink)': {
      pointerEvents: 'none',
    },
  },
  focused: {
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputLabel-error, & .MuiFormLabel-error': {
      color: theme.palette.error.main,
    },
  },
  quillEditor: {
    marginTop: '15px',
    '& .ql-editor': {
      padding: '6px 0px 3px; !important',
      fontSize: '1rem',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
      transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '& .ql-editor:hover, & .ql-editor:focus': {
      borderBottom: '2px solid rgba(0, 0, 0, 0.87) !important',
      paddingBottom: '2px',
    },
    '& .ql-editor.ql-blank::before': {
      display: 'none',
    },
  },
}))

export { useStyles }